<script setup>
    import SubNav from "../../components/global/SubNav.vue";
    import {useRoute} from "vue-router";
    import {ref} from "vue";

    const route = useRoute()

    const links = ref([
        { to: '/calls/open', label: 'Open'},
        { to: '/calls/complete', label: 'Complete'},
        { to: '/calls/stats', label: 'Stats'},
    ]);

</script>

<template>
    <sub-nav :links="links" v-if="route.name !== 'tickets-single'" />
    <router-view v-slot="{ Component }">
        <keep-alive :include="['CallsOpenView', 'CallsCompletedView']">
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
